import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'rsuite';

const DropZone = ({
  dragOverActive,
  resolvingDrop,
  COLORS,
  onDragOver,
  onDragEnter,
  onDragLeave,
  onDrop,
  style,
  children,
}) => (
  <div
    {...{
      onDragOver,
      onDragEnter,
      onDragLeave,
      onDrop,
    }}
    style={style}
  >
    {dragOverActive && (
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          border: `2px dashed ${COLORS.dropHighlight}`,
          backgroundColor: COLORS.dropHighlightBg,
          borderRadius: 4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 100,
          pointerEvents: 'none',
        }}
      >
        <div style={{ textAlign: 'center', color: COLORS.dropHighlight, fontWeight: 'bold' }}>
          📎 Drop card here to add to collection
        </div>
      </div>
    )}

    {resolvingDrop && (
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 101,
        }}
      >
        <Loader content="Resolving card..." />
      </div>
    )}

    {children}
  </div>
);

DropZone.propTypes = {
  dragOverActive: PropTypes.bool,
  resolvingDrop: PropTypes.bool,
  COLORS: PropTypes.object.isRequired,
  onDragOver: PropTypes.func.isRequired,
  onDragEnter: PropTypes.func.isRequired,
  onDragLeave: PropTypes.func.isRequired,
  onDrop: PropTypes.func.isRequired,
  style: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

DropZone.defaultProps = {
  dragOverActive: false,
  resolvingDrop: false,
};

export default DropZone;
